import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const RetakeResult = () => {

  const params = useParams();
  const { getRetakeResultsById } = useContext(AdminContext);

  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);


 
  useEffect(() => {

    getRetakeResultsById(params.id).then((res) => {
      if (res.response) {
        return setError(res.response.data.message);
      }

      document.title = 'Пересдача "'+ res.data.category.category+ '"'
      return setResults(res.data);
    });
  }, [getRetakeResultsById, params.id]);

   
  return (
    <div className="container">
      <div className="admin__results">

        <ButtonBack />
        {!results && !error ? (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        ) : error ? (
          <ErrorMessage message={error} />
        ) : !results.results.length ? (
          <>
            <div className="admin__retake__title">
              Категория: {results.category.category}
            </div>
            <div className="admin__retake__title">
              Пересдали тест:
              <span id="result_counter">{results.results.length}</span>
            </div>
            <ErrorMessage message="Нет данных" />
          </>
        ) : (
          <>
            <div className="admin__retake__title">
              Категория: {results.category.category}
            </div>
            <div className="admin__retake__title">
              Пересдали тест:
              <span id="result_counter">{results.results.length}</span>
            </div>

            <table className="table" id="table">
              <thead>
                <tr>
                  <th>Фамилия, имя</th>
                  <th>Аптека №</th>
                  <th>Результат</th>
                  <th>Результат %</th>
                  <th>Результат пересдачи</th>
                  <th>Результат пересдачи%</th>
                  <th>Среднее арифметическое</th>
                  <th>Среднее арифметическое %</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {results.results.map((res) => (
                  <tr className="search__item" key={res.id}>
                    <td>
                      {res.surname} {res.name}
                    </td>
                    <td style={{ textAlign: "center" }}>{res.ap}</td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {res.f_current_ball}/{res.total_ball}
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {((res.f_current_ball * 100) / res.total_ball).toFixed(1)}
                      %
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {res.current_ball}/{res.total_ball}
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {((res.current_ball * 100) / res.total_ball).toFixed(1)}%
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {res.average_ball.toFixed(1)} / {res.total_ball}
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {((res.average_ball * 100) / res.total_ball).toFixed(1)}%
                    </td>

                    <td style={{ textAlign: "center" }}>{res.date_test}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default RetakeResult;
